module.exports = {
  PAYMENTMETHOD: {
    CASH: 1,
    CREDITCARD: 2,
    DEBITCARD: 3,
    ACCOUNT: 4,
  },
  INVOICEDETAILTYPES: {
    PRODUCTSALE: 1,
    REFUND: 2,
    DEPOSIT: 3,
    BILLPAYMENT: 4,
    SURCHARGE: 5,
    REPAIR: 6,
    DISCOUNT: 7,
    COUPON: 8,
    MISCELLANEOUS: 9,
    MVNOACTIVATION: 10,
  },
  COMMISSIONTYPE: {
    PERCENTOFPROFIT: 1,
    AMOUNTPERUNIT: 2,
    PERCENTOFSALE: 3,
    POINTPERUNIT: 4,
  },
  ACTIVATIONEVENT: {
    STANDARDACTIVATION: 1,
    PORTIN: 2,
    UPGRADE: 3,
    MULTILINEPLAN: 4,
    SINGLEPLANUNLIMITED: 5,
    MULTILINEPLANUNLIMITED: 6,
  },
  MASTERCATEGORY: {
    SERIALIZED: 1,
    ITEMIZED: 2,
    SERVICE: 3,
  },
  ORDERSOURCE: {
    INTERNAL: 1,
    EXTERNAL: 2,
    FOURPICKUP: 3,
    ECOMMERCE: 4,
  },
  PAYMENTPROCESSOR: {
    MERCHANTINDUSTRYDEJAVOO: 1,
    VANTIVDEJAVOO: 2,
    PARAGONPAX: 3,
    STRIPETERMINAL: 4,
  },
}
